const BASE = process.env.REACT_APP_API_URL || '';

let _activeToken = null;

export function setApiToken(token) {
  _activeToken = token;
}

export function getApiToken() {
  return _activeToken || localStorage.getItem('cafepos_token');
}

async function request(method, path, body) {
  const headers = { 'Content-Type': 'application/json' };
  const token = getApiToken();
  if (token) headers['Authorization'] = `Bearer ${token}`;
  const res = await fetch(`${BASE}/api${path}`, {
    method, headers,
    body: body ? JSON.stringify(body) : undefined,
  });
  if (res.status === 401) {
    localStorage.removeItem('cafepos_token');
    window.location.href = '/login';
    return;
  }
  const data = await res.json();
  if (!res.ok) throw new Error(data.error || 'Błąd serwera');
  return data;
}

const api = {
  login:          (username, password) => request('POST', '/auth/login', { username, password }),
  getTables:      ()                   => request('GET',  '/tables'),
  updateTable:    (id, data)           => request('PATCH', `/tables/${id}`, data),
  getMenu:        ()                   => request('GET',  '/menu'),
  getMenuAll:     ()                   => request('GET',  '/menu/all'),
  updateMenuItem: (id, data)           => request('PATCH', `/menu/${id}`, data),

  getOrders: (params = {}) => {
    const q = new URLSearchParams(params).toString();
    return request('GET', `/orders${q ? '?' + q : ''}`);
  },
  createOrder: (table_id, items, payment_method, contractor_id) =>
    request('POST', '/orders', {
      table_id, items,
      ...(payment_method ? { payment_method } : {}),
      ...(contractor_id ? { contractor_id } : {}),
    }),

  setKitchenStatus: (id, kitchen_status)  => request('PATCH', `/orders/${id}/kitchen`,  { kitchen_status }),
  setDelivered:     (id)                  => request('PATCH', `/orders/${id}/delivery`,  {}),
  setPayment:       (id, payment_method)  => request('PATCH', `/orders/${id}/payment`,   { payment_method }),
  cancelOrder:      (id)                  => request('PATCH', `/orders/${id}/cancel`,    {}),

  getStatsToday: () => request('GET', '/stats/today'),

  // Faktury
  getInvoices:   (params = {}) => request('GET', `/invoices?${new URLSearchParams(params)}`),
  getInvoice:    (id)          => request('GET', `/invoices/${id}`),
  createInvoice: (data)        => request('POST', '/invoices', data),
  sendKSeF:      (id)          => request('POST', `/invoices/${id}/send-ksef`),
};

export default api;
